import { useEffect, useState } from "react";
import moment from "moment";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";
import { KPTextform } from "../../../../components/KPTComponents";
import { Close } from "@material-ui/icons";

import styles from "./index.module.css";
import { apiCall } from "../../../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { scientificCouncilAction } from "../../../../reducer/scientificCouncil/action";
import select from "../../../../utils/select";
import { uploadMultiFile } from "../../../../reducer/file/action";
import { Autocomplete } from "@material-ui/lab";

const ScientificCouncil = (props) => {
  const { open, handleClose } = props;
  const [values, setValues] = useState(null);

  const role = useSelector((state) => select(state, "userReducer", "role"));
  const departments = useSelector((state) => select(state, "departmentReducer", "departments"));
  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));
  const timeResearchInformationList = useSelector((state) => select(state, "timeResearchInformationReducer", "list"));

  const timeResearchInformationOptions = timeResearchInformationList
    .find((item) => item.year === props.year)
    ?.timeResearchDetail?.filter((e) => e.type == "scientificCouncil")
    .map((item) => ({
      title: item.description,
      value: item.code,
      mapCode: item.mapCode,
    }));
  // console.log(timeResearchInformationOptions, values);

  const TEXT_FORM = [
    {
      key: "title",
      xs: 12,
      disabled: props.viewValues,
      required: true,
      label: () => (
        <>
          <Typography className="kpt-textfield-label" color="primary">
            Tên đối tượng:
          </Typography>
          <Typography variant="body2" color="primary">
            (Đối tượng có thể là nhóm nghiên cứu, đề tài, giáo trình, hội thảo tùy thuộc vào Phân loại Hội đồng)
          </Typography>
        </>
      ),
    },
    {
      xs: 12,
      key: "department",
      disabled: props.viewValues,
      required: true,
      label: "Khoa/Viện",
      type: "autoComplete",
      getOptionLabel: (option) => option.name,
      options: departments.filter((item) => item.id !== 0) ?? [],
    },
    {
      xs: 12,
      key: "executionTime",
      disabled: props.viewValues,
      type: "date",
      label: "Thời điểm thực hiện",
      required: true,
    },
    {
      xs: 12,
      key: "type",
      disabled: props.viewValues,
      type: "select",
      label: "Phân loại hội đồng",
      required: true,
      options: [
        ...[
          { title: "Hội đồng đánh giá Hồ sơ thành lập Nhóm nghiên cứu", value: "research_group" },
          { title: "Hội đồng đánh giá đề tài nghiên cứu cấp cơ sở", value: "internal_research_council" },
          { title: "Hội đồng nghiệm thu giáo trình", value: "textbook" },
          { title: "Tổ chức hội thảo, Tọa đàm khoa học cấp Trường", value: "uni_seminar" },
          { title: "Tổ chức Hội thảo, Tọa đàm khoa học cấp Khoa/Viện", value: "faculty_seminar" },
          {
            title: "Hội đồng khoa học đánh giá các đề tài tham gia Hội nghị sinh viên NCKH cấp trường",
            value: "student_research_reviewer",
          },
        ].map((d, i) => ({
          key: `opt${i}`,
          title: d.title,
          value: d.value,
        })),
      ],
    },
    {
      xs: 6,
      key: "info",
      disabled: props.viewValues,
      type: "text",
      label: () => (
        <>
          <Typography className="kpt-textfield-label" color="primary">
            Thông tin đối tượng<span style={{ color: "#c90000" }}>*</span>:
          </Typography>
          <Typography variant="body2" color="primary">
            (Tên trưởng nhóm nghiên cứu/Mã số đề tài/Tên người soạn giáo trình…)
          </Typography>
        </>
      ),
      required: true,
    },
    {
      xs: 6,
      key: "role",
      disabled: props.viewValues,
      type: "select",
      label: () => (
        <>
          <Typography variant="body2" color="primary">
            &nbsp;
          </Typography>
          <Typography className="kpt-textfield-label" color="primary">
            Vai trò<span style={{ color: "#c90000" }}>*</span>:
          </Typography>
        </>
      ),
      options: (() => {
        var listOption = [
          { title: "Chủ tịch HĐ", value: "chairman" },
          { title: "Thư kí HĐ", value: "secretary" },
        ];
        if (!(values?.type === "uni_seminar" || values?.type === "faculty_seminar")) {
          listOption = [
            ...listOption,
            { title: "Ủy viên", value: "commissioner" },
            { title: "Ủy viên phản biện", value: "reviewer" },
          ];
        }
        return listOption.map((d, i) => ({
          key: `opt${1}`,
          title: d.title,
          value: d.value,
        }));
      })(),
      // options: [
      //   ...[
      //     {title: "Chủ tịch HĐ", value: "chairman"},
      //     {title: "Thư kí HĐ", value: "secretary"},
      //     {title: "Ủy viên", value: "commissioner"},
      //     {title: "Ủy viên phản biện", value: "reviewer"},
      //   ].map((d, i) => ({
      //     key: `opt${1}`,
      //     title: d.title,
      //     value: d.value
      //   }))
      // ],
      required: true,
    },
    {
      xs: 12,
      key: "timeResearchDetailCode",
      label: "Nhiệm vụ tính giờ nghiên cứu",
      disabled: true,
      required: true,
      type: "select",
      options: timeResearchInformationOptions,
    },
    { xs: 12, disabled: props.viewValues, key: "fileUrl", type: "dragzone", label: "Minh chứng", required: true },
  ];

  const dispatch = useDispatch();

  const insert = () => {
    dispatch(uploadMultiFile(profileDetail?.id, { file: values?.fileUrl })).then((res) => {
      if (res.success) {
        const files = res.data;

        // Chuyển đổi executionTime từ DD/MM/YYYY sang ISO datetime
        const executionTime =
          values.executionTime && values.executionTime !== "dd/mm/yyyy"
            ? moment(values.executionTime, "DD/MM/YYYY").toISOString()
            : null;

        dispatch(
          scientificCouncilAction.createAllScientificCouncli({
            ...values,
            profileId: profileDetail.id,
            departmentId: values.department.id,
            executionTime,
            fileUrl: files[0],
          })
        ).then(() => {
          props.reload();
          setValues(null);
        });
      }
    });
  };

  const accept = (accepted) =>
    dispatch(
      scientificCouncilAction.updateAllScientificCouncli({
        accepted,
        id: props.viewValues.id,
      })
    ).then(() => props.reload());

  const handleSubmit = () => {
    if (!!props.viewValues) {
      if (role === "sudo-admin") {
        accept(!props.viewValues.accepted);
      }
    } else {
      insert();
    }
    handleClose();
  };

  useEffect(() => {
    if (props.year) {
      setValues({
        ...values,
        year: props.year,
      });
    }
  }, [props.year]);

  // if has role and type in values, set timeResearchDetailCode to type_role by mapCode
  useEffect(() => {
    if (values?.role && values?.type) {
      const mapCode = `${values.type}_${values.role}`;
      const matchedOption = timeResearchInformationOptions.find((option) => option.mapCode === mapCode);
      if (matchedOption) {
        setValues((prevValues) => ({
          ...prevValues,
          timeResearchDetailCode: matchedOption.value,
        }));
      }
    }
  }, [values?.role, values?.type]);

  // Chuyển đổi executionTime từ datetime ISO sang DD/MM/YYYY khi có viewValues
  const displayValues = props.viewValues
    ? {
        ...props.viewValues,
        executionTime: props.viewValues.executionTime
          ? moment(props.viewValues.executionTime).format("DD/MM/YYYY")
          : "dd/mm/yyyy",
      }
    : values;

  return (
    <Dialog fullWidth maxWidth="md" open={open}>
      {/* {isFetching && <LinearProgress />} */}
      <DialogTitle classes={{ root: styles["dialog-title-container"] }}>
        <Grid container>
          <Grid item xs={7} classes={{ root: styles["dialog-title"] }}>
            <Typography variant="h5">
              <b>Khai báo thành viên hội đồng khoa học</b>
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <IconButton
              onClick={() => {
                handleClose();
                setValues(null);
              }}
              style={{ float: "right" }}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <KPTextform
          id="scientificCouncil"
          textForm={TEXT_FORM}
          values={displayValues}
          setValues={!props.viewValues && setValues}
          handleSubmit={handleSubmit}
        />
      </DialogContent>
      <DialogActions style={{ padding: "8px 24px" }}>
        <Button
          type="submit"
          form="scientificCouncil"
          variant="contained"
          color="primary"
          disabled={!props.viewValues && !values?.fileUrl}
        >
          {(() => {
            if (!!props.viewValues) {
              if (role === "sudo-admin") {
                return props.viewValues.accepted ? "Huỷ duyệt" : "Duyệt";
              } else {
                return "Đóng";
              }
            } else {
              return "Thêm";
            }
          })()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScientificCouncil;

